import type { TFiberType } from '@/lib/api/SportsbookSocketManager';
import type { TSocketBatchAction } from '@/config/constants';

export const aggregateSocketToStoreBunch = (payloads: TPayload[]) => {
  const payloadsById = new Map();

  for (const payload of payloads) {
    const {
      value: { lid },
      model,
      action,
    } = payload;

    const key = `${model}-${lid}-${action}`;
    const existingPayload = payloadsById.get(key);

    if (!existingPayload) {
      payloadsById.set(key, payload);
    } else {
      payloadsById.set(key, { ...existingPayload, ...payload });
    }
  }

  return Array.from(payloadsById.values());
};

interface TPayload {
  value: {
    id: string;
    lid: string;
  };
  model: TFiberType;
  action: TSocketBatchAction;
}
